import { newApiFetch } from "./utils";

type IDiagnosticToken = {
  url: string;
  dash_auth_token: string;
};

export const getUserGroupDiagnosticToken = (): Promise<IDiagnosticToken> => newApiFetch("/diagnostic_funnel_api/generate_token", {});
